// Angular
import {Component, OnInit, OnDestroy, ChangeDetectorRef} from '@angular/core';

import {Subscription} from 'rxjs';

import {UserService} from '../../../../../mbs/services/user/user.service';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {LazyLoadEvent, ConfirmationService} from 'primeng/api';
import { RoleService } from '../../../../../mbs/services/role/role.service';
import { Router } from '@angular/router';
import { Row } from 'jspdf-autotable';

// Table with EDIT item in MODAL
// ARTICLE for table with sort/filter/paginator
// https://blog.angular-university.io/angular-material-data-table/
// https://v5.material.angular.io/components/table/overview
// https://v5.material.angular.io/components/sort/overview
// https://v5.material.angular.io/components/table/overview#sorting
// https://www.youtube.com/watch?v=NSt9CI3BXv4
@Component({
    selector: 'kt-users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./user-list.component.scss'],
})
export class UsersListComponent implements OnInit, OnDestroy {
    roles: any[];
    users: any[];
    datasource: any[];
    userCount: number;
    loading: boolean;
    columns: any[];

    tableRows = 10;
    tableCurrentFirst = 0;

    // yeni kullanıcı ekle
    addUserDialog = false;
    addUserForm = new FormGroup({
        id: new FormControl(0),
        firstName: new FormControl('', [Validators.required, Validators.min(2), Validators.max(150)]),
        lastName: new FormControl('', [Validators.required, Validators.min(2), Validators.max(150)]),
        email: new FormControl('', [Validators.required, Validators.email]),
        userName: new FormControl('', [Validators.required, Validators.minLength(2)]),
        password: new FormControl('', [Validators.required, Validators.minLength(4)]),
        passwordRepeat: new FormControl('', [Validators.required, Validators.minLength(4)]),
        isPasswordUpdated: new FormControl(true),
    });

    // Subscriptions
    private subscriptions: Subscription[] = [];

    constructor(
        private cdr: ChangeDetectorRef,
        private userService: UserService,
        private roleService: RoleService,
        private confirmationService: ConfirmationService,
        private router: Router
    ) {
    }

    ngOnInit(): void {
        // this.getAllUsers();

        this.columns = [
            {field: 'id', header: 'No', width: '70px'},
            {field: 'firstName', header: 'Adı'},
            {field: 'lastName', header: 'Soyadı'},
            {field: 'userName', header: 'Kullanıcı Adı'},
            {field: 'email', header: 'Eposta'},
            {field: 'actions', header: 'İşlemler', custom: true, width: '250px'},
        ];
        this.roleService.getRoles().subscribe((roles) => {
            this.roles = roles
                .filter((t) => t.id !== 0)
                .map((t) => {
                    t.selected = false;
                    return t;
                });
        });
        this.addUserForm.controls.isPasswordUpdated.valueChanges.subscribe((value) => {
            if (value) {
                this.addUserForm.controls.password.enable();
                this.addUserForm.controls.passwordRepeat.enable();
            } else {
                this.addUserForm.controls.password.disable();
                this.addUserForm.controls.passwordRepeat.disable();
            }
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach((el) => el.unsubscribe());
    }

    showDialogForUserEdit(rowData) {
        this.roles = this.roles.map((p) => {
            p.selected = rowData.roles.some((pid) => pid === p.id);
            return p;
        });
        this.addUserForm.patchValue({...rowData, isPasswordUpdated: false});
        this.addUserDialog = true;
    }

    showDetailForUser(rowData) {
        this.router.navigate(['/user-management/users-detail', rowData.id]);
        //this.router.navigate(['/user-management/users-detail', rowData.id]);
        //this.router.navigate(['/user-management/users-detail'], { queryParams: { id: rowData.id } });
    }

    getUsers(event: LazyLoadEvent) {
        this.loading = true;
        const page = ((event.first / event.rows) + 1).toString();
        const pageSize = event.rows.toString();
        this.tableCurrentFirst = event.first;

        let pagedRequest = {page, pageSize};

        if (event.globalFilter) {
            Object.assign(pagedRequest, {searchTerm: event.globalFilter});
        }

        this.subscriptions.push(
            this.userService.getUsers(pagedRequest).subscribe({
                next: (users) => {
                    this.datasource = users.results;
                    this.userCount = users.rowCount;
                    this.users = this.datasource;
                    this.loading = false;
                    this.cdr.detectChanges();
                },
            })
        );
    }

    getAllUsers() {
        this.getUsers({first: this.tableCurrentFirst, rows: this.tableRows});
    }

    addUser() {
        const user = this.addUserForm.getRawValue();
        user.roles = this.roles.filter((t) => t.selected === true).map((p) => p.id);

        if (this.addUserForm.controls.id.value === 0) {
            this.userService.addUser(user).subscribe(() => {
                this.addUserDialog = false;
                this.getAllUsers();
                this.cdr.detectChanges();
            });
        } else {
            this.userService.updateUser(user).subscribe(() => {
                this.addUserDialog = false;
                this.getAllUsers();
                this.cdr.detectChanges();
            });
        }
    }

    deleteUser(id: number) {
        this.confirmationService.confirm({
            message: 'Kayıt silinecektir! Onaylıyor musunuz?',
            accept: () => {
                this.userService.removeUser(id).subscribe(() => {
                    this.getAllUsers();
                    this.cdr.detectChanges();
                });
            },
            header: 'Onay',
            acceptLabel: 'Evet',
            rejectLabel: 'Hayır',
        });
    }

    updateEducationInformationFromYoksis(id: number) {
        this.confirmationService.confirm({
            header: 'Onay',
            acceptLabel: 'Evet',
            rejectLabel: 'Hayır',
            message: 'Eğitim bilgileri Yöksis üzerinden güncellenecektir. Devam etmek istiyor musunuz?',
            accept: () => {
                this.userService.updateEducationInformationFromYoksis(id).subscribe(() => {
                    this.cdr.detectChanges();
                });
            },
        });
    }

    updateIdentificationInformationFromMernis(id: number) {
        this.confirmationService.confirm({
            header: 'Onay',
            acceptLabel: 'Evet',
            rejectLabel: 'Hayır',
            message: 'Kimlik bilgileri Mernis üzerinden güncellenecektir. Devam etmek istiyor musunuz?',
            accept: () => {
                this.userService.updateUserDetailFromMernis(id).subscribe(() => {
                    this.cdr.detectChanges();
                });
            },
        });
    }

    checkAddUserForm(controlName: string, validationType: string = null, validOrinvalidCheck: string = null): boolean {
        const control = this.addUserForm.controls[controlName];
        if (!control) {
            return false;
        }

        if (validationType) {
            return control.hasError(validationType) && (control.dirty || control.touched);
        } else {
            return (control.touched || control.dirty) && validOrinvalidCheck === 'iv' ? !!control.errors : !control.errors;
        }
    }
}
